import { DropdownSmall } from "@components/Icons"
import { useIntl } from "@components/Intl"
import { Box } from "@components/Layout"
import React, { useState } from "react"
import * as S from "./elements"

export interface OpeningTimes {
  day?: string
  hours?: string
}

interface Props {
  title: string
  subtitle: string
  tel: string
  mail: string
  url: string | null
  openingHours?: OpeningTimes[]
}

export const SingleStore: React.FC<Props> = ({
  title,
  subtitle,
  tel,
  mail,
  url,
  openingHours,
  children,
}) => {
  const { messages } = useIntl()
  const [visible, setVisible] = useState(false)
  const regex = new RegExp(
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g
  )

  return (
    <Box mb="3">
      <S.Title as="h3">{title}</S.Title>
      <S.Subtitle color={"text.light"}>{subtitle}</S.Subtitle>
      <S.Content>{children}</S.Content>
      <S.ContactWrapper>
        <span>T:</span>
        <S.ContactLink>
          <a title="call us" href={`tel:${tel}`}>
            {tel}
          </a>
        </S.ContactLink>
      </S.ContactWrapper>
      <S.ContactWrapper>
        <span>E:</span>
        <S.ContactLink>
          <a title="send an email" href={`mailto:${mail}`}>
            {mail}
          </a>
        </S.ContactLink>
      </S.ContactWrapper>
      {url && url.match(regex) && (
        <S.ContactWrapper>
          <span>W:</span>
          <S.ContactLink>
            <a title="go to retailer website" href={url} target="blank">
              {messages.retailers.visitSite}
            </a>
          </S.ContactLink>
        </S.ContactWrapper>
      )}
      <S.ToggleButton onClick={() => setVisible(!visible)} open={visible}>
        {messages.retailers.openingHours}
        <DropdownSmall />
      </S.ToggleButton>
      {openingHours && (
        <Box display={visible ? "block" : "none"} aria-hidden={!visible}>
          {openingHours.map((item, key) => (
            <Box
              display="grid"
              key={key}
              pb="1"
              maxWidth="14rem"
              gridTemplateColumns={"1fr 1fr"}
            >
              <span>{item.day}</span>
              <span>{item.hours}</span>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  )
}
